import styled from 'styled-components';
import { Box } from '@mui/material';

export const StyledCountWithSubtitleContainer = styled(Box)`
  & > .link-style {
    color: blue;
    text-decoration: underline;
  }

  .subtitle {
    padding-left: 5px;
    font-size: 10px;
  }

  .clickable {
    cursor: pointer;
  }
`;
